<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    spin: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    baseClass() {
      let bc = {
        't-icon': this.icon,
        't-disabled': this.disabled,
      }

      bc[`t-${this.size}`] = this.size

      this.spin.split(' ').forEach(sc => {
        bc[`t-${sc}`] = this.spin
      })

      return bc
    },

    iconClass() {
      return this.icon
    },
  },
}
</script>
